import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { OptionDropdown, SelectControl } from '../../../create-request/models/OptionDropdownSelect';
import { CodeAndDescription } from '../../../create-request/models/shared/CodeAndDescription';
import { createControl } from '../../../create-request/utilities/formUtilities';
import { AchTransactionDetailsForm, CheckTransactionDetailsForm, ItTransactionDetailsForm, RecurringFrequencyValues } from '../../../create-request/models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-recurring-frequency-selector',
  templateUrl: './recurring-frequency-selector.component.html',
  styleUrls: ['./recurring-frequency-selector.component.scss']
})
export class RecurringFrequencySelectorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isAch: boolean = false;
  @Input() isEditRecurringSubmittedCheckTransaction: boolean = false;
  @Input() parentForm: FormGroup<CheckTransactionDetailsForm | AchTransactionDetailsForm | ItTransactionDetailsForm>;
  @Input() set frequencyList(list: CodeAndDescription[]) {
    this._frequencyList = list;
    this.setDropDownOptions();
  };
  @Output() frequencyChanged = new EventEmitter<string>();
  readonly formConrolName: string = 'recurringFrequency';
  recurringFrequencyModel: SelectControl = {
    title: 'Set frequency of recurring transfer',
    controlName: this.formConrolName,
    options: [],
    validationMessage: `Please select 'Frequency' from dropdown.`
  };
  destroy$: Subject<boolean> = new Subject<boolean>();
  private _frequencyList: CodeAndDescription[];

  constructor() { }

  ngOnInit(): void {
    createControl(this.parentForm, 'recurringFrequency', '', [Validators.required]);
    if (this.isEditRecurringSubmittedCheckTransaction) {
      this.setControlDisabledState();
    }

    this.frequency.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.frequencyChanged.emit(value);
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isEditRecurringSubmittedCheckTransaction']) {
      this.setControlDisabledState();
    }
  }

  ngOnDestroy() {
    this.parentForm.removeControl('recurringFrequency');

    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  setDropDownOptions(): void {
    this.recurringFrequencyModel.options = this.frequencyList
      .filter(element => element.code !== 'ACCRUED' && element.description !== 'Select One')
      .map(element => new OptionDropdown(element.code, element.description));
  }

  get frequency(): FormControl<typeof RecurringFrequencyValues[number]> {
    return this.parentForm?.get(this.formConrolName) as FormControl<typeof RecurringFrequencyValues[number]>;
  }

  get frequencyList(): CodeAndDescription[] {
    return this._frequencyList;
  }

  private setControlDisabledState(): void {
    const control = this.frequency;
    if (!control) {
      return;
    }

    if (this.isEditRecurringSubmittedCheckTransaction) {
      control.disable({ emitEvent: false });
    } else {
      control.enable({ emitEvent: false });
    }
  }
}
